import { debounce } from "../../utils/functions";

const init = (callback) => {
  // For mobile vh.
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  window.addEventListener(
    "resize",
    debounce(function () {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }, 200)
  );
};

export default init;
